import { createAction } from '@reduxjs/toolkit';
import { site } from 'lib/src/shared/enums/site';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge, ChallengeDescriptionSectionRequest } from 'src/types/shared/Challenge';

export const editChallengeRequest = createAction('editChallengeRequest');
export const editChallengeSuccess = createAction<Challenge>('editChallengeSuccess');
export const editChallengeFailure = createAction('editChallengeFailure');

export const editChallenge = (id: number, postbody: EditChallengeRequest) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(editChallengeRequest());
    try {
        const { data } = await api.patch<EditChallengeRequest, Challenge>(
            'admin/challenges/' + id,
            postbody,
        );

        dispatch(editChallengeSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, editChallengeFailure, e);
    }
};

export interface EditChallengeRequest {
    name: string;
    startDate: Date | string;
    endDate: Date | string;
    // number of days after end date to allow finishing application
    gracePeriod: number;
    // description
    background: string;
    imageS3Key: string | null;
    partnerLogoS3Key: string | null;
    partnerSecondLogoS3Key: string | null;
    partnerThirdLogoS3Key: string | null;
    summaryImage1S3Key: string | null;
    summaryImage2S3Key: string | null;
    responseDate: Date | string;
    challengeLeadID: number | null;
    tagIDs: number[];
    businessTagIDs: number[];
    site: site;
    descriptionSections: ChallengeDescriptionSectionRequest[];
    workshopDate: Date | string;
    workshopAdminIDs: number[];
    assessmentStartDate: Date | string;
    assessorIDs: number[];
    pitchPresentationDate: Date | string;
    pitchPresentationAdminIDs: number[];
}
